import type { FC } from 'react'
import { EdgeSubstruct } from '../atoms/EdgeSubstruct'

export const FullEdgeDeco: FC = () => {
	return (
		<div className="w-full absolute left-0 bottom-0 z-20 flex h-object-edge" aria-hidden="true">
			<div className="grow bg-(--color-theme-edge-bg)" />
			<EdgeSubstruct className="aspect-edge text-(--color-theme-edge-bg)" />
		</div>
	)
}
